export const VALID_COLOR_REGEX =
  /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$|^rgb\(|^rgba\(|^hsl\(|^hsla\(|^color\(/;

export function isValidColor(value: string | undefined): boolean {
  const v = typeof value === 'string' ? value.trim() : '';
  return v !== '' && VALID_COLOR_REGEX.test(v);
}

export function normalizeHex(value: string | undefined): string {
  if (!value?.trim()) return '';
  const v = value.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(v)) return v;
  if (/^[0-9A-Fa-f]{6}$/.test(v)) return `#${v}`;
  return v;
}
